import {
  IoCloseCircleOutline,
  IoNotificationsOutline,
  IoChevronForward,
} from 'react-icons/io5';
import { Header2 } from '../../components/header';
import { CxControle, TanqueStyled } from '../../styles/tanques';
import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { TanqueContextC } from '../../contexts/contextTanque';
import {
  GraficosByTanque,
  GraficosTanquesC,
  ModalAlertas,
  ModalConfimacaoBombaTanque,
  VazaoModal,
} from './modals';
import { SquareLoading } from '../../components/loaders';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { LuPower, LuPowerOff } from 'react-icons/lu';
import { PiArrowsClockwiseBold } from 'react-icons/pi';
import { IoMdWifi } from 'react-icons/io';
import { HeaderMobile } from '../../components/mobileHeader';
import { toast } from 'react-toastify';
import { estaOnline, obterMotivoBloqueioComando } from './regrasComandoTanque';
import {
  classificarAlerta,
  formatarDataHoraAlerta,
  limparMensagemAlerta,
} from './formatarAlerta';

export const Tanque = () => {
  const {
    setModalAlertas,
    modalAlertas,
    tanquesList,
    setTanquesList,
    modalConfimetionBomba,
    setModalConfimationBomba,
    setIdControlerBomba,
    modalVazao,
    setModalVazao,
  } = useContext(TanqueContextC);

  const { socket, headerApi } = useContext(HomeContext);

  const [graficoName, setGraficoName] = useState('Todos os Tanques');
  const [tanqueId, setTanqueId] = useState(null);
  const [mensagemModal, setMensagemModal] = useState(null);
  const [alertasList, setAlertas] = useState([]);
  const [statusTanques, setStatusTanques] = useState([]);
  const [modalVazaoSave, setModalVazaoSave] = useState([]);
  const [pendingCommandTankId, setPendingCommandTankId] = useState(null);
  const tanquesRef = useRef(tanquesList);
  const headerApiRef = useRef(headerApi);
  const graficoRef = useRef(null);
  const refreshTanquesTimeoutRef = useRef(null);
  const pendingCommandTimeoutRef = useRef(null);

  const ListTanques = useCallback(async () => {
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');

      const response = await apiJalles.get(`tanque/LeituraTodos/${idUnidade}`, headerApiRef.current);
      setTanquesList(response.data);
      // console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [setTanquesList]);

  const listAlertasTanque = useCallback(async () => {
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');
      const response = await apiJalles.get(`/alertas/tanque/Leitura/${idUnidade}`, headerApiRef.current);
      setAlertas(response.data);
      // console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const verifStatusGtwPoco = useCallback(async () => {
    try {
      const status = await apiJalles.get(`/users/tanques/list`, headerApiRef.current);
      setStatusTanques(status.data);
      // if (idGTw != null) {
      // }
    } catch (error) {
      console.log('erro na verificação do status do tanque', error);
    }
  }, []);

  const refreshTanquesDebounced = useCallback(() => {
    if (refreshTanquesTimeoutRef.current) {
      clearTimeout(refreshTanquesTimeoutRef.current);
    }

    refreshTanquesTimeoutRef.current = setTimeout(() => {
      ListTanques();
    }, 700);
  }, [ListTanques]);

  const resumirTexto = useCallback((texto, limite = 110) => {
    if (!texto) return '';

    const textoLimpo = String(texto).replace(/\s+/g, ' ').trim();
    if (textoLimpo.length <= limite) return textoLimpo;

    return `${textoLimpo.slice(0, limite - 3)}...`;
  }, []);

  const getMensagemAlerta = useCallback((alerta) => {
    if (!alerta) return '';

    return (
      alerta.mensagem ||
      alerta.alerta?.mensagem ||
      alerta.data?.mensagem ||
      alerta.payload?.mensagem ||
      alerta.message ||
      ''
    );
  }, []);

  const handlePing = useCallback((tanque) => {
    if (!socket) {
      toast.error('Socket desconectado. Tente novamente em alguns segundos.');
      return;
    }

    socket.emit('ping_gateway', {
      id: tanque.id,
      nome_tanque: tanque.nome_tanque,
      gtw_tanque: tanque.gtw_tanque,
    });
    toast.success('Comando Feito com sucesso', {
      position: 'top-right',
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'dark',
    });
  }, [socket]);

  const abrirHistoricoTanque = useCallback((tanque) => {
    if (Number(tanque.painel) === 3) return;

    setTanqueId(tanque.id);
    setGraficoName(tanque.nome_tanque);

    requestAnimationFrame(() => {
      graficoRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  }, []);

  useEffect(() => {
    ListTanques();
    verifStatusGtwPoco();
    listAlertasTanque();
  }, [ListTanques, verifStatusGtwPoco, listAlertasTanque]);

  useEffect(() => {
    headerApiRef.current = headerApi;
  }, [headerApi]);

  useEffect(() => {
    tanquesRef.current = tanquesList;
  }, [tanquesList]);

  const tanquesOrdenados = useMemo(() => {
    return [...(tanquesList || [])]
      .filter((tanque) => tanque.ativo)
      .sort((a, b) => a.nome_tanque.localeCompare(b.nome_tanque));
  }, [tanquesList]);

  const tanquesGrafico = useMemo(() => {
    return tanquesOrdenados.filter((tanque) => tanque.painel !== 3);
  }, [tanquesOrdenados]);

  const statusPorTanque = useMemo(() => {
    const statusMap = new Map();

    statusTanques.forEach((status) => {
      if (status.tanque != null) {
        statusMap.set(status.tanque, status.online);
      }
    });

    return statusMap;
  }, [statusTanques]);

  const statusPorGateway = useMemo(() => {
    const statusMap = new Map();

    statusTanques.forEach((status) => {
      if (status.gateway != null) {
        statusMap.set(status.gateway, status.online);
      }
    });

    return statusMap;
  }, [statusTanques]);

  const validarComandoBomba = useCallback(
    (controlerId) => {
      const tanque = tanquesOrdenados.find((item) =>
        (item.bombas || []).some((bomba) => bomba.bombaControler?.[0]?.id === controlerId),
      );
      const bomba = tanque?.bombas?.find(
        (item) => item.bombaControler?.[0]?.id === controlerId,
      );

      if (!tanque || !bomba) {
        toast.error('Controle da bomba não encontrado. Atualize a página e tente novamente.');
        return false;
      }

      const statusTanque =
        statusPorTanque.get(tanque.id) ?? statusPorTanque.get(tanque.usuario_tanque);
      const statusGtw = statusPorGateway.get(tanque.gtw_tanque);
      const motivoBloqueio = obterMotivoBloqueioComando({
        tanque,
        bomba,
        statusTanque,
        statusGtw,
      });

      if (motivoBloqueio) {
        toast.warn(motivoBloqueio);
        return false;
      }

      return true;
    },
    [statusPorGateway, statusPorTanque, tanquesOrdenados],
  );

  useEffect(() => {
    if (!socket) return;

    const handleTanqueUpdate = (data) => {
      refreshTanquesDebounced();
      // console.log('recebendo tanqueUpdate', data);
    };

    const handleBombaEdit = (data) => {
      // console.log('recebendo BombaTanque_edit', data);
      refreshTanquesDebounced();
    };

    const handleControlerEdit = (data) => {
      // console.log('recebendo ControlerBomba_edit', data);
    };

    const handleUpdateControler = () => {
      refreshTanquesDebounced();
    };

    const handleChangedUser = () => {
      verifStatusGtwPoco();
    };

    const handleCreateAlert = (alerta) => {
      listAlertasTanque();

      const mensagem = getMensagemAlerta(alerta);
      if (mensagem) {
        toast.warn(resumirTexto(mensagem), {
          position: 'top-right',
          autoClose: 5000,
          theme: 'dark',
        });
      }
    };

    const handlePong = (Data) => {
      // console.log('recebendo pong_gateway', Data);
      // console.log('Lista de tanques:', tanquesRef.current);

      const tankId = Data.tankID ?? Data.tankId;
      const pongTanque = tanquesRef.current?.find((e) => e.id === tankId);

      if (!pongTanque) return;

      if (Data.status === 'success') {
        toast.info(`Gateway Comunicado com Tanque: ${pongTanque.nome_tanque}`);
      } else {
        toast.error(`Gateway não conseguiu comunicar com Tanque: ${pongTanque.nome_tanque}`);
      }
    };

    socket.on('tanqueUpdate', handleTanqueUpdate);
    socket.on('BombaTanque_edit', handleBombaEdit);
    socket.on('ControlerBomba_edit', handleControlerEdit);
    socket.on('update_ControlerBombaTanque', handleUpdateControler);
    socket.on('changed_user', handleChangedUser);
    socket.on('creat_alerta', handleCreateAlert);
    socket.on('pong_gateway', handlePong);

    // 🔥 IMPORTANTE: cleanup quando desmontar
    return () => {
      socket.off('tanqueUpdate', handleTanqueUpdate);
      socket.off('BombaTanque_edit', handleBombaEdit);
      socket.off('ControlerBomba_edit', handleControlerEdit);
      socket.off('update_ControlerBombaTanque', handleUpdateControler);
      socket.off('changed_user', handleChangedUser);
      socket.off('creat_alerta', handleCreateAlert);
      socket.off('pong_gateway', handlePong);

      if (refreshTanquesTimeoutRef.current) {
        clearTimeout(refreshTanquesTimeoutRef.current);
      }
    };
  }, [
    socket,
    refreshTanquesDebounced,
    verifStatusGtwPoco,
    listAlertasTanque,
    getMensagemAlerta,
    resumirTexto,
  ]);

  useEffect(() => {
    if (modalAlertas || modalConfimetionBomba || modalVazao) {
      document.body.classList.add('modal-open'); // Adiciona a classe overflow-hidden ao body quando o modal é aberto
    } else {
      document.body.classList.remove('modal-open'); // Remove a classe overflow-hidden do body quando o modal é fechado
    }

    // Limpa a classe quando o componente é desmontado para evitar vazamentos de memória
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalAlertas, modalConfimetionBomba, modalVazao]);

  useEffect(() => {
    if (modalConfimetionBomba || pendingCommandTankId == null) return;

    if (pendingCommandTimeoutRef.current) {
      clearTimeout(pendingCommandTimeoutRef.current);
    }

    pendingCommandTimeoutRef.current = setTimeout(() => {
      setPendingCommandTankId(null);
    }, 2500);

    return () => {
      if (pendingCommandTimeoutRef.current) {
        clearTimeout(pendingCommandTimeoutRef.current);
      }
    };
  }, [modalConfimetionBomba, pendingCommandTankId]);

  if (!tanquesList) {
    return (
      <TanqueStyled>
        <SquareLoading />
      </TanqueStyled>
    );
  }

  return (
    <TanqueStyled>
      <Header2 />
      <HeaderMobile />
      {modalAlertas && <ModalAlertas />}
      {modalVazao && (
        <VazaoModal vazao={modalVazaoSave} validarComando={validarComandoBomba} />
      )}

      {modalConfimetionBomba && (
        <ModalConfimacaoBombaTanque
          mensagem={mensagemModal}
          validarComando={validarComandoBomba}
        />
      )}

      <section className="sectionTanque">
        <button
          type="button"
          className="avisos"
          aria-label="Abrir histórico de alertas"
          title="Alertas dos tanques"
          onClick={() => setModalAlertas(true)}
        >
          <IoNotificationsOutline />
        </button>

        <div ref={graficoRef} className="containerSuperior">
          {graficoName !== 'Todos os Tanques' && (
            <span
              onClick={() => {
                setGraficoName('Todos os Tanques');
              }}
              className="close"
            >
              <IoCloseCircleOutline />
            </span>
          )}

          <div className="graficos">
            {graficoName === 'Todos os Tanques' ? (
              <GraficosTanquesC TanquesData={tanquesGrafico} />
            ) : (
              <GraficosByTanque TanqueDataId={tanqueId} TanqueNome={graficoName} />
            )}
          </div>
          <div className="containerAlertas">
            <div className="alertas">
              <header className="alertasCabecalho">
                <div>
                  <span className="alertasContexto">Monitoramento</span>
                  <h4>Alertas recentes</h4>
                </div>
                <button
                  type="button"
                  className="alertasQuantidade"
                  aria-label="Abrir histórico de alertas"
                  title="Ver histórico de alertas"
                  onClick={() => setModalAlertas(true)}
                >
                  <IoNotificationsOutline />
                  {alertasList.count ?? alertasList.results?.length ?? 0}
                </button>
              </header>

              <ul className="alertasResumo">
                {alertasList.results?.slice(0, 4).map((alert, index) => {
                  const { diaCurto, hora } = formatarDataHoraAlerta(alert.createdAt);
                  const classificacao = classificarAlerta(alert.mensagem);

                  return (
                    <li key={alert.id ?? `${alert.createdAt}-${index}`}>
                      <button type="button" onClick={() => setModalAlertas(true)}>
                        <span className={`alertaIndicador ${classificacao.tipo}`} />
                        <span className="alertaConteudo">
                          <strong>{limparMensagemAlerta(alert.mensagem)}</strong>
                          <small>{alert.usuario?.nome || 'Sistema'}</small>
                        </span>
                        <time dateTime={alert.createdAt}>
                          {diaCurto}
                          <strong>{hora}</strong>
                        </time>
                      </button>
                    </li>
                  );
                })}

                {alertasList.results?.length === 0 && (
                  <li className="alertasVazio">Nenhum alerta registrado.</li>
                )}
              </ul>

              <div className="alertasAcoes">
                <button
                  type="button"
                  className="botaoHistorico"
                  onClick={() => setModalAlertas(true)}
                >
                  Ver histórico
                  <IoChevronForward />
                </button>
                {graficoName !== 'Todos os Tanques' && (
                  <button
                    type="button"
                    className="acaoSecundaria"
                    onClick={() => setGraficoName('Todos os Tanques')}
                  >
                    Todos os tanques
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="containerInferior">
          <ul>
            {tanquesOrdenados.map((tanques) => {
                const bombas = tanques.bombas || [];
                const tanqueComComandoAtivo =
                  pendingCommandTankId === tanques.id ||
                  bombas.some((bomba) => bomba.bombaControler?.[0]?.comando);
                const statusTanque = estaOnline(
                  statusPorTanque.get(tanques.id) ?? statusPorTanque.get(tanques.usuario_tanque),
                );
                const statusGtw = estaOnline(statusPorGateway.get(tanques.gtw_tanque));
                const modoPainel = Number(tanques.painel);
                const temHistoricoNivel = modoPainel !== 3;
                const somenteNivel = modoPainel === 2;

                return (
                  <li key={tanques.id}>
                    {temHistoricoNivel ? (
                      <button
                        type="button"
                        className="tanqueTitulo"
                        onClick={() => abrirHistoricoTanque(tanques)}
                        aria-label={`Ver histórico de nível do tanque ${tanques.nome_tanque}`}
                      >
                        <span>{tanques.nome_tanque}</span>
                        <small>
                          Ver histórico
                          <IoChevronForward />
                        </small>
                      </button>
                    ) : (
                      <div className="tanqueTitulo tanqueTituloSemHistorico">
                        <span>{tanques.nome_tanque}</span>
                        <small>Sem medição de nível</small>
                      </div>
                    )}
                    <div className="containerInfos">
                      <IoMdWifi
                        className={`gtwStatus ${statusGtw ? 'gtwStatusON' : 'gtwStatusOFF'}`}
                        role="img"
                        aria-label={`Gateway ${statusGtw ? 'online' : 'offline'}`}
                        title={`Gateway ${statusGtw ? 'online' : 'offline'}`}
                      />
                      <div className={`ping ${!statusGtw ? 'PingGTWOFF' : ''}`}>
                        <button
                          type="button"
                          onClick={() => {
                            if (!statusGtw) {
                              toast.warn('Ping bloqueado: o gateway está offline.');
                              return;
                            }

                            if (tanqueComComandoAtivo) {
                              toast.warn('Comando em andamento. Aguarde finalizar.');
                              return;
                            }

                            handlePing(tanques);
                          }}
                          aria-disabled={!statusGtw}
                          className={!statusGtw ? 'desativado' : ''}
                          title={
                            !statusGtw
                              ? 'Ping bloqueado: o gateway está offline.'
                              : 'Enviar ping para o gateway'
                          }
                        >
                          Ping Lora...
                        </button>
                      </div>
                      <div
                        className={statusTanque ? 'tanqueOn' : 'tanqueOff'}
                        role="status"
                        aria-label={`Tanque ${statusTanque ? 'online' : 'offline'}`}
                        title={`Tanque ${statusTanque ? 'online' : 'offline'}`}
                      />
                      <div className="conteinerLimite">
                        <div className="infos">
                          {Number(tanques.painel) !== 3 && (
                            <>
                              <div className="info">
                                <p>Nível</p>
                                <span>{tanques.nivel_atual}%</span>
                              </div>

                              <div className="barraNivelVerticalWrapper">
                                <span>100%</span>

                                <div className="barraNivelVertical">
                                  <div
                                    className="barraNivelVerticalAtual"
                                    style={{
                                      '--nivel': `${Math.min(
                                        Math.max(Number(tanques.nivel_atual) || 0, 0),
                                        100,
                                      )}%`,
                                    }}
                                  />
                                </div>

                                <span>0%</span>
                              </div>
                            </>
                          )}
                          <div className="info">
                            <p>Bombas</p>
                            <span>{bombas.length}</span>
                          </div>
                          {bombas.length > 0 &&
                            bombas.map((bomba, index) => {
                              const horimetro = Number(bomba.horimetro) || 0;

                              return (
                                <Fragment key={bomba.id || index}>
                                  <div className="info">
                                    <p>Corrente B{index + 1}</p>
                                    <span>{bomba.corrente ?? 0} A</span>
                                  </div>
                                  <div className="info">
                                    <p>Horímetro B{index + 1}</p>
                                    <span>
                                      {`${Math.floor(horimetro)}:${Math.floor(
                                        (horimetro % 1) * 60,
                                      )
                                        .toString()
                                        .padStart(2, '0')}`}
                                    </span>
                                  </div>
                                </Fragment>
                              );
                            })}
                        </div>
                        <div className={`conteinerStatus ${somenteNivel ? 'somenteNivel' : ''}`}>
                          <div className="status">
                            <div>
                              <p>Modo de Controle</p>
                            </div>
                            {Number(tanques.painel) === 0 && (
                              <div className="controle">
                                <div className="divControler">
                                  <CxControle
                                    activo={
                                      Number(tanques.automatico) === 1
                                        ? 'rgb(53, 53, 53)'
                                        : 'transparent'
                                    }
                                  ></CxControle>
                                  <p>Remoto</p>
                                </div>

                                <div className="divControler">
                                  <CxControle
                                    activo={
                                      Number(tanques.automatico) === 0
                                        ? 'rgb(53, 53, 53)'
                                        : 'transparent'
                                    }
                                  ></CxControle>
                                  <p>Manual</p>
                                </div>
                              </div>
                            )}
                            {somenteNivel && (
                              <div className="modoSomenteNivel">
                                <strong>Somente monitoramento de nível</strong>
                                <span>Sem comandos de bombas</span>
                              </div>
                            )}
                          </div>

                          <div className="status">
                            {bombas.length > 0 &&
                              bombas.map((bomba, index) => {
                                const bombaControler = bomba.bombaControler?.[0];
                                const comandoBomba = bombaControler?.comando ?? false;
                                const controlerId = bombaControler?.id;
                                const motivoBloqueio = obterMotivoBloqueioComando({
                                  tanque: tanques,
                                  bomba,
                                  statusTanque,
                                  statusGtw,
                                });
                                const comandoDesativado =
                                  !controlerId ||
                                  tanqueComComandoAtivo ||
                                  Boolean(motivoBloqueio);
                                const tituloComando = !controlerId
                                  ? 'Comando bloqueado: controle da bomba não encontrado.'
                                  : tanqueComComandoAtivo
                                    ? 'Comando em andamento. Aguarde finalizar.'
                                    : motivoBloqueio;
                                const exibirMotivoBloqueio = () => {
                                  if (!comandoDesativado) return false;

                                  if (!controlerId) {
                                    toast.error(tituloComando);
                                  } else {
                                    toast.warn(tituloComando);
                                  }

                                  return true;
                                };

                                return (
                                  <div key={bomba.id || index} className="Bombas">
                                    {(tanques.painel === 1 || tanques.painel === 3) && (
                                      <div className="status">
                                        <div className="controle">
                                          <div className="divControler">
                                            <CxControle
                                              activo={
                                                Number(bomba.automatico) === 1
                                                  ? 'rgb(53, 53, 53)'
                                                  : 'transparent'
                                              }
                                            ></CxControle>
                                            <p>Remoto</p>
                                          </div>

                                          <div className="divControler">
                                            <CxControle
                                              activo={
                                                Number(bomba.automatico) === 0
                                                  ? 'rgb(53, 53, 53)'
                                                  : 'transparent'
                                              }
                                            ></CxControle>
                                            <p>Manual</p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <span>Bomba - {index + 1}</span>

                                    <button
                                      aria-disabled={comandoDesativado}
                                      title={tituloComando}
                                      onClick={() => {
                                        if (exibirMotivoBloqueio()) return;

                                        setPendingCommandTankId(tanques.id);
                                        setIdControlerBomba(controlerId);
                                        setModalConfimationBomba(true);
                                        setMensagemModal(bomba.status ? 'Desligar' : 'Ligar');
                                      }}
                                      className={
                                        comandoDesativado ? 'desativado' : ''
                                      }
                                    >
                                      {comandoBomba ? (
                                        <PiArrowsClockwiseBold
                                          className={`icon ${comandoBomba && 'butonOff'}`}
                                        />
                                      ) : Number(bomba.status) === 1 ? (
                                        <LuPower className="icon IconeOn" />
                                      ) : (
                                        <LuPowerOff className="icon" />
                                      )}
                                      {Number(bomba.status) === 1 ? 'Ligada' : 'Desligada'}
                                    </button>
                                    {bomba.vazao !== null && bomba.vazao !== undefined && (
                                      <>
                                        <button
                                          aria-disabled={comandoDesativado}
                                          title={tituloComando}
                                          onClick={() => {
                                            if (exibirMotivoBloqueio()) return;

                                            setModalVazao(true);
                                            setModalVazaoSave([controlerId, bomba.vazao]);
                                          }}
                                          className={comandoDesativado ? 'desativado' : ''}
                                        >
                                          Vazão
                                        </button>
                                        <div className="info">
                                          <span>{bomba.vazao}%</span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </section>
    </TanqueStyled>
  );
};
